import { parse } from 'date-fns';

export const parseFormattedDate = (dateStr) => {
    return parse(dateStr, 'dd.MM.y', new Date());
};
